// extracted by mini-css-extract-plugin
export var icon = "_53-1";
export var subtext = "_53-0";